import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

interface UploadDialogProps {
  open: boolean;
  onClose: () => void;
  handleUpload: (event: React.FormEvent<HTMLFormElement>) => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UploadDialog: React.FC<UploadDialogProps> = ({
  open,
  onClose,
  handleUpload,
  handleFileChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Upload File</DialogTitle>
      <DialogContent>
        <form id="file-upload-form" onSubmit={handleUpload}>
          <TextField
            type="file"
            fullWidth
            onChange={handleFileChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button form="file-upload-form" type="submit" color="primary">
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
